import React from "react";
import {
  getUserDisplayName,
  getUserSecondaryLabel,
  shouldShowUserSecondaryLabel,
} from "../utils/userDisplay";

const UserPickerOption = ({ user, inline = false }) => {
  const name = getUserDisplayName(user);
  const secondary = getUserSecondaryLabel(user);
  const showSecondary = shouldShowUserSecondaryLabel(user) && secondary;

  if (inline || !showSecondary) {
    return <span>{name}</span>;
  }

  return (
    <span className="user-picker-option">
      <span className="user-picker-option-name">{name}</span>
      <small className="user-picker-option-meta">{secondary}</small>
    </span>
  );
};

export default UserPickerOption;
